import { camelCase } from '@lodash';
import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import CasinoGameLaunchParams from '@models/games/CasinoGameLaunchParams';
import CasinoGameLaunchParamsDto from './dtos/CasinoGameLaunchParamsDto';

export default class CasinoGameLaunchParamsMapper
    extends AbstractMapper<CasinoGameLaunchParamsDto, CasinoGameLaunchParams> {
    createTargetObject(gameDto: CasinoGameLaunchParamsDto): CasinoGameLaunchParams {
        return gameDto.reduce(
            (acc, { Key, Value }) => ({
                ...acc,
                [camelCase(Key)]: Value,
            }),
            {}) as CasinoGameLaunchParams;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/game/CasinoGameLaunchParamsMapper.ts